import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig, isTestEnvironment } from 'config/msal/configMgmt';
import { StorageConstants } from '../../constants/storageConstants';

const msalInstance = isTestEnvironment() ? null : new PublicClientApplication(getMsalConfig());

const acquireAccessToken = async (msalInstanceMock?: PublicClientApplication | undefined): Promise<string> => {
  const msal = msalInstanceMock ?? msalInstance;
  // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  if (!isTestEnvironment() && msal) {
    const activeAccount = msal.getActiveAccount();

    if (activeAccount) {
      const accounts = msal.getAllAccounts();

      if (!activeAccount && accounts.length === 0) {
        /*
        * User is not signed in. Throw error or wait for user to login.
        * Do not attempt to log a user in outside of the context of MsalProvider
        */
      }
      const request = {
        scopes: ['https://mhob2c.onmicrosoft.com/api/tasks.read'],
        account: activeAccount || accounts[0],
        authority: sessionStorage.getItem(StorageConstants.RefreshTokenAuthority) ?? '',
      };
      const authResult: any = await msal.acquireTokenSilent(request);
      sessionStorage.setItem(StorageConstants.MsalExpiration, authResult.idTokenClaims.exp);

      return authResult.accessToken;
    }
  }

  return '';
};

export default acquireAccessToken;
